import type { TValuesTimeseriesBlocks } from 'App/Map/types'
import { ResponsiveMenuItem } from 'components/DropdownButtons/_utils/ResponsiveMenuItem'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import { selectedPropertyHasPermission } from '../../_utils/selectedPropertyHasPermission'
import { FireBlightSettingsModal } from './FireBlightSettingsModal'

type TFireBlightSettingsLinksProps = {
  valuesTimeseries: TValuesTimeseriesBlocks[]
  riskId: 'FIRE_BLIGHT_NONE' | 'FIRE_BLIGHT_LAST_YEAR' | 'FIRE_BLIGHT_ACTIVE'
}

export const FireBlightSettingsTitleLink = ({ valuesTimeseries, riskId }: TFireBlightSettingsLinksProps) => {
  const titleLink: NonNullable<StackedChartSection['titleLink']> = []

  if (!selectedPropertyHasPermission({ permission: 'EDIT_FIRE_BLIGHT_STATION_HISTORY' })) {
    return titleLink
  }

  titleLink.push(
    <>
      <ResponsiveMenuItem
        key="edit-disease-history-menu-item"
        data-role="menu-item"
        onClick={() => {
          detailsPanelStore.setState((prev) => {
            return {
              ...prev,
              fireBlightSettingsOpened: true,
            }
          })
        }}
      >
        {translate.phrases.banyanApp('Edit Disease History')}
      </ResponsiveMenuItem>
      <FireBlightSettingsModal
        key="edit-disease-history-modal"
        data-role="modal"
        valuesTimeseries={valuesTimeseries}
        riskId={riskId}
      />
    </>,
  )

  return titleLink
}
